var generalSettings = true;
window.$("#saveGeneralSettings").on('click', function () {
    generalSettings = false;
});
const getState = window.$('#generalSettings').serialize();
window.$('#generalSettings').on('change keyup keydown', 'input, textarea, select', function (e) {
    window.$(window).on('beforeunload', function () {
        if (generalSettings) {
            if (getState != window.$('#generalSettings').serialize()) {
                return "Page Leave";
            }
        }
    });
});

var reservationsForm = reservationsFormSubmitted = reservationsEditForm = reservationsEditFormSubmitted = reservationsWalkForm = reservationsWalkFormSubmitted = reservationsEditWalkForm = reservationsEditWalkFormSubmitted = reservationTimeForm = reservationTimeFormSubmit = closingTimeForm = closingTimeFormSubmit = closeIcon = false;



window.$(document).ready(function () {
    window.$(document).on('change keyup keydown input, textarea, select', '#reservationsForm, #reservationsEditForm, #reservationsWalkForm, #reservationsEditWalkForm, #reservationTimeForm, #closingTimeForm', function (e) {
        reservationsForm = reservationsEditForm = reservationsWalkForm = reservationsEditWalkForm = reservationTimeForm = closingTimeForm = reservationBackButton = reservationBackButtonWalk = closeIcon = true;
    });
    const getState1 = window.$('.richText-editor').html();
    window.$('#generalSettings').find('.richText-editor').on('keypress', function (e) {
        window.$(window).on('beforeunload', function () {
            if (generalSettings) {
                if (getState1 != window.$('.richText-editor').html()) {
                    return "Page Leave";
                }
            }
        });
    });


    window.onbeforeunload = function (e) {
        if ((reservationsEditWalkForm && !reservationsEditWalkFormSubmitted) || (reservationsWalkForm && !reservationsWalkFormSubmitted) || (reservationsEditForm && !reservationsEditFormSubmitted) || (reservationsForm && !reservationsFormSubmitted) || (reservationTimeForm && !reservationTimeFormSubmit) || (closingTimeForm && !closingTimeFormSubmit)) {
            return "Page Leave";
        }
    }
    $(document).on('click','.saveReservations, .updateReservations, .saveavilability, .closingTimeFormSave',function () {
        reservationsFormSubmitted = reservationsEditFormSubmitted = reservationsWalkFormSubmitted = reservationsEditWalkFormSubmitted = reservationTimeFormSubmit = closingTimeFormSubmit = true;
    });
    $(document).on("click", "#closeIcon", function () {
        if((closeIcon ) && (!reservationsEditFormSubmitted || !reservationsFormSubmitted || !reservationsWalkFormSubmitted || !reservationsEditWalkFormSubmitted)){
            if(confirm("Changes you made may not be saved.")){
                
            }
            else{
                window.$("#sidebarNavRight").css('width', '500px');
            }
        }
     });
});



